export default __webpack_public_path__ + "static/media/pdfIcon.87027eba.svg";